<template>
  <div v-if="!isLoading" class="container-fluid new_Header">
    <div class="row nav_Breadcrumb">
      <div class="col">
        <nav>
          <ol class="breadcrumb">
            <li class="breadcrumb-item mx-3"><router-link  to="/">{{$t('favoriteProperties.breadcrumb_1')}}</router-link></li>
            <i  v-if="userLang == 'ar'" class="fa-solid fa-chevron-left pt-1"></i>
            <i  v-else class="fa-solid fa-chevron-right pt-1"></i>
            <li class="active mx-3 almarai-bold" aria-current="page">{{$t('favoriteProperties.breadcrumb_2')}}</li>
          </ol>
        </nav>
      </div>
    </div>
  </div>
  <div class="container">
    <div class="row pt-2">
      <div class="col">
        <div class="row">
          <div class="col text-center">
            <mainloader v-if="isLoading" />
          </div>
        </div>
        <div class="row">
          <div class="col">
            <errorAlert v-if="hasError" :alertMessage="message" :errorNumber="errorNumber" />
          </div>
        </div>
        <div class="row pt-3">
          <div class="col-12 col-md-5 col-lg-3 mb-3" v-for="(prop,index) in properties" :key="index">
            <router-link :to="'/propertydetails/'+prop.id">
              <div class="card card-border m-auto">
                <!-- <div class="padding-4p almarai-regular position-R">
                  <span class="heart-icon" @click.prevent="addFavorite(prop.id)">
                    <i v-if="prop.Favorites.length" class="fa-solid fa-heart orange-Heart"></i>
                    <i v-else class="fa-solid fa-heart heart"></i>
                  </span>
                  <span class="card-icon1">{{ prop.PropertyType.name }}</span>
                  <span class="card-icon2">{{value.statusChoices[prop.status]}}</span>
                  <span class="card-icon3">{{(prop.purpose == 'for_rent') ? 'للايجار' : 'للبيع' }}</span>
                  <swiper v-if="prop.mediaFiles.length" class="text-center" :modules="modules" 
                    :autoplay="{ delay: 2500, disableOnInteraction: false,}" :pagination="{ clickable: true }" :navigation="false">
                    <swiper-slide  v-for="(row, index) in prop.mediaFiles" :key="index">
                      <img :src="MEDIA_URL+row.thumbnail" alt="Slide Image" class="img-fluid br-radius" />
                    </swiper-slide>
                  </swiper>
                  <div v-else>
                    <img src="/assets/images/defaultImage.jpg" class="img-fluid br-radius" alt="">
                  </div>
                </div> -->
                <div class="card-body position-R">
                  <div class="row statusBar">
                    <div class="col-auto tag-style">
                      <span class="">{{ prop.PropertyType.name }}</span>
                    </div>
                    <div class="col-auto tag-style">
                      <span class="">{{value.statusChoices[prop.status]}}</span>
                    </div>
                    <div class="col-auto tag-style">
                      <span class="">{{(prop.purpose == 'for_rent') ? $t('rent') : (prop.purpose == 'for_sale') ? $t('sale')  : $t('investment') }}</span>
                    </div>
                  </div>
                  <span v-if="prop.Favorites && prop.Favorites.length" class="heart-icon" @click.prevent="removeFavorite(prop.id, 'properties', index)">
                    <i  class="fa-solid fa-heart orange-Heart"></i>
                  </span>
                  <span v-else class="heart-icon" @click.prevent="addFavorite(prop.id, 'properties', index)">
                    <i class="fa-solid fa-heart heart"></i>
                  </span>
                  <swiper v-if="prop.mediaFiles.length" class="text-center" 
                    :modules="modules" :pagination="{ clickable: true }" 
                    :spaceBetween="30" :centeredSlides="true" 
                    :autoplay="{ delay: 2500,disableOnInteraction: false,}" :navigation="false">
                    <swiper-slide  v-for="(row, index) in prop.mediaFiles" :key="index">
                      <img :src="MEDIA_URL+row.thumbnail" alt="Slide Image" class="w-100 br-radius" />
                    </swiper-slide>
                  </swiper>
                  <div v-else>
                    <placeHolder/>
                  </div>

                  <div class="text-title">{{ prop.title }}</div>

                  <div class="row pt-1">
                    <div class="col-auto px-2 content-center">
                      <i class="fa-solid fa-location-dot gray-color"></i>
                    </div>
                    <div class="col p-0 fontGray-73 content-center">
                      <div class="d-flex">
                        {{ prop.City?.name }}
                        <span class="mx-1">{{ prop.Neighborhood?.name }}</span>
                      </div>
                    </div>
                  </div>
                  <hr class="border-color-w">
                  <div class="row space end-card">
                    <div class="col">
                      <span class="mx-1 green-color-F icon-saudi_riyal_bold_new"></span>
                      <span class="green-color-F">{{ prop.price }}</span>
                      <!-- <span class="mx-1 green-color-F">{{$t('currency')}}</span> -->
                    </div>

                    <div class="col-auto content-center" v-if="prop.roomsCount && prop.bathrooms">
                      <div class="row">
                        <div class="col-auto content-center">
                          <span> 
                            <img :src="MEDIA_URL + value.countedIcons.roomsCount.path" 
                              class="max-width-28"
                              alt=""/>
                          </span>
                          <span class="numbers">{{ prop.roomsCount }}</span>
                        </div>
                        <div class="col-auto border_Icons">
                          <span>
                            <img :src="MEDIA_URL + value.countedIcons.bathrooms.path"
                              class="max-width-28"
                              alt=""/>
                          </span>
                          <span class="numbers">{{ prop.bathrooms }}</span>
                        </div>
                      </div>
                    </div>
                    <div v-else class="col-auto content-center">
                      <span>
                        <img :src="MEDIA_URL + value.countedIcons.area.path"
                          class="max-width-28"
                          alt=""/>
                      </span>
                      <span class="numbers">
                        {{ prop.area }}
                        <span>{{ $t("areaSymbol") }}</span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </router-link>
          </div>
        </div>
        <div class="row" v-if="!properties.length">
          <div class="col">
            <div class="row pt-5">
              <div  class="col text-center">
                <img src="/assets/images/icons/Frame-9.png" class="width-56"  alt="">
                <div class="almarai-bold pt-2 text-center">{{$t('favoriteProperties.title_1')}}</div>
                <div class="text-center almarai-regular gray-color fonttext-14">
                  <span>{{$t('favoriteProperties.title_2')}}</span>
                </div>
              </div>
            </div>
            
            <div class="row justify-content-center pb-5">
              <div class="col-12 col-md-8 text-center py-3">
                <router-link to="/">
                  <button class="submit-button form-control almarai-bold">{{$t('favoriteProperties.title_3')}}</button>
                </router-link>
              </div>  
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--begin:modal login-->
    <div class="modal bg-modal" dir="rtl" tabindex="-1" id="formLogin">
      <div class="modal-dialog max-w">
        <div class="modal-content">
          <button type="button" class="btn-close m-2" @click.prevent="closeingFN" id="modal-close" data-bs-dismiss="modal" aria-label="Close"></button>
          <!-- <div class="modal-header">
            <h5 class="modal-title">Modal title</h5>
          </div> -->
          <div class="modal-body">
            <div class="row justify-content-center">
              <div class="col text-center">
                <div class="font-24 almarai-bold">{{$t('formLogin.title_1')}}</div>
                <p class="almarai-regular gray-color"> {{$t('formLogin.title_2')}} <br> {{$t('formLogin.title_3')}}</p>
              </div>
            </div>
            <div class="row pt-3">
              <div class="col-12 mb-2">
                <router-link to="/login">
                  <button class="login-btn rounded-pill form-control almarai-bold">{{$t('formLogin.title_4')}}</button>
                </router-link>
              </div>
              <div class="col-12">
                <router-link to="/register">
                  <button class="form-control rounded-pill p-2 createAccount" >
                    {{$t('formLogin.title_5')}} <span class="text-color extrabold ">{{$t('formLogin.title_6')}}</span>
                  </button>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--end:modal Login-->
  </div>
</template>
<script>
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Pagination, Navigation, Autoplay } from "swiper/modules";
import { mapGetters } from "vuex";
export default {
  name: 'favorite',
  components: { Swiper, SwiperSlide },
  setup() {
    return {
      modules: [Autoplay, Pagination, Navigation]
    };
  },
  data(){
    return{
      hasError: false,
      message: "",
      isLoading: true,
      errorNumber: 0,
      properties: [],
      value: {},
      userLang: 'ar',
    }
  },
  computed:{
    ...mapGetters(['MEDIA_URL', 'GET_USER'])
  },
  methods:{
    favoriteList(){
      this.hasError = false;
      this.$http.get("/api/favorites/list").then(res => {
        // console.log(res);
        this.value = res.data;
        this.properties = res.data.rows;
        this.isLoading = false;
      }).catch(err => {
        // console.log(err);
        this.isLoading = false;
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
      });
    },
    addFavorite(id, dataName, index){
      this.hasError = false;
      if(!this.GET_USER){
        document.getElementById('formLogin').style.display = "block";
        return false;
      }
      this.$http.post("/api/favorites/add",{
        propertyId: id,
      }).then(res => {
        // console.log(res);
        if(dataName == 'properties'){
          this.properties[index].Favorites = [{}];
        }
        this.loading = false;
      }).catch(err => {
        // console.log(err);
        this.loading = false;
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
      });
    },

    removeFavorite(id, dataName, index){
      if(!this.GET_USER){
        document.getElementById('formLogin').style.display = "block";
        return false;
      }
      this.hasError = false;
      this.$http.delete("/api/favorites/remove/"+id).then(res => {
        // console.log(res);
        if(dataName == 'properties'){
          this.properties[index].Favorites = [];
        }
        this.loading = false;
      }).catch(err => {
        // console.log(err);
        this.loading = false;
        [this.message, this.errorNumber] = this.$globalError(err,true);
        this.hasError = true;
      });
    },
  },
  created(){
    this.favoriteList();
    this.userLang = localStorage.getItem('lang') ?? 'ar';
    window.scrollTo({top:0, behavior: 'smooth'});
  }
}
</script>